import React from 'react';
import {createStyles, makeStyles, Theme} from "@material-ui/core/styles";
import {LinearProgress, withStyles} from "@material-ui/core";
import {Colors} from "../../theme/colors";

const BorderLinearProgress = withStyles((theme: Theme) =>
    createStyles({
        root: {
            height: 10,
            borderRadius: 5,
        },
        colorPrimary: {
            backgroundColor: theme.palette.grey[theme.palette.type === 'light' ? 200 : 700],
        },
        bar: {
            borderRadius: 5,
        },
    }),
)(LinearProgress);


const useStyles = makeStyles<Theme, any>({
    root: {
        flexGrow: 1,
    },
    bar: {
        "& .MuiLinearProgress-barColorPrimary": {
            backgroundColor: props => props.color,
        },
    }
});

export const CustomLinearProgress: React.FC<{value: number, color?: string}> = ({value, color}) => {
    let tmpColor = Colors.green;

    if (value < 67) {
        tmpColor = Colors.yellow;
    }

    if (value < 34) {
        tmpColor = Colors.red;
    }

    const classes = useStyles({color: color || tmpColor});

    return (
        <div className={classes.root}>
            <BorderLinearProgress className={classes.bar} variant="determinate" value={value} />
        </div>
    );
}
